//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DefaultRoleList from "./list";
export default {
  name: "DefaultRole",
  components: { DefaultRoleList },
  data() {
    return {
      activeName: "4",
    };
  },
  methods: {},
  created() {},
};
